import * as fromDatatype from '../datatype-library';

export interface bl_fi_entity_calendar_event_hdr_RowInterface {
    guid: fromDatatype.GuidDataFieldInterface;
    entity_hdr_guid: fromDatatype.GuidDataFieldInterface;
    default_calendar_hdr_guid: fromDatatype.GuidDataFieldInterface;
    title: fromDatatype.VarcharDatatypeInterface;
    timezone: fromDatatype.VarcharDatatypeInterface;
    visibility_setting: fromDatatype.VarcharDatatypeInterface;
    description: fromDatatype.VarcharDatatypeInterface;
    icon_color: fromDatatype.VarcharDatatypeInterface;
    venue_address: fromDatatype.VarcharDatatypeInterface;
    venue_map_url: fromDatatype.VarcharDatatypeInterface;
    venue_gps: fromDatatype.VarcharDatatypeInterface;
    venue_name: fromDatatype.VarcharDatatypeInterface;
    property_json: fromDatatype.JsonDatatypeInterface;
    notification_json: fromDatatype.JsonDatatypeInterface;
    is_full_day: boolean;
    start_date: fromDatatype.TimestampTzDatatypeInterface;
    end_date: fromDatatype.TimestampTzDatatypeInterface;
    file_attachment_guid: fromDatatype.GuidDataFieldInterface;
    recurring_group_01_guid: fromDatatype.GuidDataFieldInterface;
    recurring_group_02_guid: fromDatatype.GuidDataFieldInterface;
    rrule: fromDatatype.VarcharDatatypeInterface;
    is_recurring: boolean;
    recurring_update_type: fromDatatype.VarcharDatatypeInterface;
    created_by_subject_guid: fromDatatype.GuidDataFieldInterface;
    updated_by_subject_guid: fromDatatype.GuidDataFieldInterface;
    created_date: fromDatatype.TimestampTzDatatypeInterface;
    updated_date: fromDatatype.TimestampTzDatatypeInterface;
    status: fromDatatype.StatusDataFieldInterface;
    revision: fromDatatype.RevisionDataFieldInterface;
    vrsn: fromDatatype.VrsnDataFieldInterface;
    type: fromDatatype.VarcharDatatypeInterface;
}

export class bl_fi_entity_calendar_event_hdr_RowClass implements bl_fi_entity_calendar_event_hdr_RowInterface {
    guid: fromDatatype.GuidDataFieldInterface;
    entity_hdr_guid: fromDatatype.GuidDataFieldInterface;
    default_calendar_hdr_guid: fromDatatype.GuidDataFieldInterface;
    title: fromDatatype.VarcharDatatypeInterface;
    timezone: fromDatatype.VarcharDatatypeInterface;
    visibility_setting: fromDatatype.VarcharDatatypeInterface;
    description: fromDatatype.VarcharDatatypeInterface;
    icon_color: fromDatatype.VarcharDatatypeInterface;
    venue_address: fromDatatype.VarcharDatatypeInterface;
    venue_map_url: fromDatatype.VarcharDatatypeInterface;
    venue_gps: fromDatatype.VarcharDatatypeInterface;
    venue_name: fromDatatype.VarcharDatatypeInterface;
    property_json: fromDatatype.JsonDatatypeInterface;
    notification_json: fromDatatype.JsonDatatypeInterface;
    is_full_day: boolean;
    start_date: fromDatatype.TimestampTzDatatypeInterface;
    end_date: fromDatatype.TimestampTzDatatypeInterface;
    file_attachment_guid: fromDatatype.GuidDataFieldInterface;
    recurring_group_01_guid: fromDatatype.GuidDataFieldInterface;
    recurring_group_02_guid: fromDatatype.GuidDataFieldInterface;
    rrule: fromDatatype.VarcharDatatypeInterface;
    is_recurring: boolean;
    recurring_update_type: fromDatatype.VarcharDatatypeInterface;
    created_by_subject_guid: fromDatatype.GuidDataFieldInterface;
    updated_by_subject_guid: fromDatatype.GuidDataFieldInterface;
    created_date: fromDatatype.TimestampTzDatatypeInterface;
    updated_date: fromDatatype.TimestampTzDatatypeInterface;
    status: fromDatatype.StatusDataFieldInterface;
    revision: fromDatatype.RevisionDataFieldInterface;
    vrsn: fromDatatype.VrsnDataFieldInterface;
    type: fromDatatype.VarcharDatatypeInterface;
}
